import React, { useState } from 'react'
import { router, usePage } from '@inertiajs/react'
import {
  Alert,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

const POLICY_LABELS = {
  disabled:  { title: 'Deaktiviert',          description: 'Keine zusätzliche Absicherung beim Login.' },
  otp_email: { title: 'OTP per E-Mail',       description: 'Benutzer erhalten bei jedem Login einen 6-stelligen Code per E-Mail.' },
  totp_app:  { title: 'Authenticator-App',    description: 'Benutzer richten beim nächsten Login eine Authenticator-App (TOTP) ein und bestätigen die Anmeldung mit einem Code.' },
}

export default function Show({ two_factor_required: twoFactorRequired, allowed_policies: allowedPolicies }) {
  const { props } = usePage()
  const tenantSlug = props.auth?.tenant?.slug || props.tenant?.slug
  const flash = props.flash || {}

  const [policy, setPolicy] = useState(twoFactorRequired)
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitting(true)
    router.patch(
      `/m/${tenantSlug}/settings/security`,
      { tenant: { two_factor_required: policy } },
      { onFinish: () => setSubmitting(false) }
    )
  }

  return (
    <Box sx={{ p: 3 }}>
      <PageHeader
        breadcrumbs={[
          { label: 'Einstellungen', href: `/m/${tenantSlug}/settings/users` },
          { label: 'Sicherheit' },
        ]}
        title="Sicherheit"
      />

      {flash.alert && <Alert severity="error" sx={{ mb: 2 }} data-testid="security-flash-alert">{flash.alert}</Alert>}
      {flash.notice && <Alert severity="success" sx={{ mb: 2 }} data-testid="security-flash-notice">{flash.notice}</Alert>}

      <Paper elevation={0} sx={{ p: 3, border: 1, borderColor: 'divider' }} component="form" onSubmit={handleSubmit}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Zwei-Faktor-Authentifizierung (2FA)
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Legen Sie fest, wie sich Benutzer dieses Mandanten zusätzlich zum
          Passwort ausweisen müssen. Die Einstellung gilt für alle Benutzer des
          Mandanten beim nächsten Login.
        </Typography>

        <FormControl>
          <RadioGroup
            value={policy}
            onChange={(e) => setPolicy(e.target.value)}
            data-testid="two-factor-radio-group"
          >
            {allowedPolicies.map((p) => (
              <FormControlLabel
                key={p}
                value={p}
                control={<Radio slotProps={{ input: { 'data-testid': `tfa-radio-${p}` } }} />}
                label={
                  <Box sx={{ py: 0.5 }}>
                    <Typography variant="body1" fontWeight={500}>{POLICY_LABELS[p].title}</Typography>
                    <Typography variant="body2" color="text.secondary">{POLICY_LABELS[p].description}</Typography>
                  </Box>
                }
                sx={{ alignItems: 'flex-start', mb: 1 }}
              />
            ))}
          </RadioGroup>
        </FormControl>

        <Box sx={{ mt: 3 }}>
          <Button
            type="submit"
            variant="contained"
            disabled={submitting || policy === twoFactorRequired}
            data-testid="security-submit-button"
          >
            {submitting ? 'Speichern...' : 'Speichern'}
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}

Show.layout = (page) => <AppShell>{page}</AppShell>
